<template>
  <global-modal name="alert-modal" @before-open="beforeOpen">
    <Modal popup @close="$modal.hide('alert-modal')">
      <section class="alert-modal popup-modal">
        <div class="popup-modal__header">
          <span class="popup-modal__title">
            {{ data | localeField("title") }}
          </span>
        </div>
        <div class="popup-modal__body">
          <span class="popup-modal__text">
            {{ data | localeField("text") }}
          </span>
          <Notification
            class="alert-modal__alert"
            icon="warning-border--no-color"
            v-if="$options.filters.localeField(data, 'warning')"
            modify="_flex"
          >
            {{ $options.filters.localeField(data, "warning") }}
          </Notification>
        </div>
      </section>
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import { Notification } from "@v2/shared/ui/components";

export default {
  name: "AlertModal",
  components: {
    Notification,
    Modal
  },
  data() {
    return {
      data: {}
    };
  },
  methods: {
    beforeOpen(event) {
      if (event.params.data) {
        this.data = event.params.data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-modal {
  &__alert {
    margin-top: 15px;
  }
}
</style>
